import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function EditFoodDialog({ editingFood, setEditingFood, handleUpdateFood, L }) {
  if (!editingFood) return null;
  return (
    <Dialog open={!!editingFood} onOpenChange={() => setEditingFood(null)}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Lebensmittel bearbeiten</DialogTitle>
          <DialogDescription>Makronährstoffe pro 100g anpassen</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Name (PT)</label>
            <Input value={editingFood.name} onChange={e => setEditingFood(p => ({ ...p, name: e.target.value }))} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-semibold text-blue-600 uppercase mb-1 block">Name (DE)</label>
              <Input value={editingFood.name_de || ""} onChange={e => setEditingFood(p => ({ ...p, name_de: e.target.value }))} placeholder="Deutsch..." />
            </div>
            <div>
              <label className="text-xs font-semibold text-violet-600 uppercase mb-1 block">Name (EN)</label>
              <Input value={editingFood.name_en || ""} onChange={e => setEditingFood(p => ({ ...p, name_en: e.target.value }))} placeholder="English..." />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 mb-1 block">Referenzmenge (g)</label>
            <div className="flex items-center gap-2">
              <Input type="number" value={editingFood.serving_size ?? 100} onChange={e => setEditingFood(p => ({ ...p, serving_size: e.target.value }))} className="w-24" />
              <span className="text-xs text-slate-400">Alle Nährwerte beziehen sich auf diese Menge</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-semibold text-slate-500 mb-1 block">Kalorien <span className="text-slate-400">/{editingFood.serving_size ?? 100}g</span></label>
              <Input type="number" value={editingFood.calories} onChange={e => setEditingFood(p => ({ ...p, calories: e.target.value }))} />
            </div>
            <div>
              <label className="text-xs font-semibold text-blue-600 mb-1 block">Protein (g) <span className="text-slate-400">/{editingFood.serving_size ?? 100}g</span></label>
              <Input type="number" value={editingFood.protein} onChange={e => setEditingFood(p => ({ ...p, protein: e.target.value }))} className="border-blue-200 focus:border-blue-400" />
            </div>
            <div>
              <label className="text-xs font-semibold text-amber-600 mb-1 block">Kohlenhydrate (g) <span className="text-slate-400">/{editingFood.serving_size ?? 100}g</span></label>
              <Input type="number" value={editingFood.carbs} onChange={e => setEditingFood(p => ({ ...p, carbs: e.target.value }))} className="border-amber-200 focus:border-amber-400" />
            </div>
            <div>
              <label className="text-xs font-semibold text-rose-600 mb-1 block">Fett (g) <span className="text-slate-400">/{editingFood.serving_size ?? 100}g</span></label>
              <Input type="number" value={editingFood.fat} onChange={e => setEditingFood(p => ({ ...p, fat: e.target.value }))} className="border-rose-200 focus:border-rose-400" />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Beschreibung</label>
            <textarea value={editingFood.description || ""} onChange={e => setEditingFood(p => ({ ...p, description: e.target.value }))}
              className="w-full text-sm p-2 border border-slate-200 rounded-md resize-y min-h-[60px] focus:outline-none focus:border-blue-400"
              placeholder="Einnahmeempfehlung, Zubereitungstipp, Allergie-Hinweis..." rows={2} />
          </div>
          <Button onClick={() => handleUpdateFood(editingFood)} className="w-full">{L.save}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
